import type { components } from "@connect/data/frames/schema";
import type { AddCardMessageMap } from "@connect/post-message/protocol";

type AddedCard = components["schemas"]["MoonPay.Payments.AddedCardPaymentMethodResponse"];

// Frames create-card already returns the stored-card shape the wire uses.
// last4 from tokenization is only a fallback if the API omits it.
export function mapCreatedCard(
  data: AddedCard,
  fallbackLast4: string,
): AddCardMessageMap["complete"]["card"] {
  return {
    id: data.id,
    type: "card",
    cardType: data.cardType,
    brand: data.brand,
    last4: data.last4 || fallbackLast4,
    expirationMonth: data.expirationMonth,
    expirationYear: data.expirationYear,
    availability: { active: true },
  };
}
